import React, { Component } from 'react';
import { Logo, Navigation, Wrapper } from '.';
import { MobileNavigationButton } from './Mobile';
import './Header.scss';

const isClient = typeof window !== 'undefined';

class Header extends Component {
  state = {
    headerHeight: 0,
    viewportTopPos: 0,
    scrollingUp: false,
  };

  componentDidMount() {
    const headerHeight = this.headerRef.clientHeight;
    this.setState({ headerHeight });
    if (isClient) {
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
    }
  }

  componentWillUnmount() {
    if (isClient) window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const { viewportTopPos: prevTopPos } = this.state;
    const newTopPos = window.scrollY;
    this.setState({
      viewportTopPos: newTopPos,
      scrollingUp: Boolean(prevTopPos > newTopPos),
    });
  }

  render() {
    const {
      location,
      settings,
      navOpen,
      isMobile,
      toggleNavHandler,
    } = this.props;
    const {
      primaryMenu,
    } = settings;
    const {
      viewportTopPos,
      scrollingUp,
      headerHeight,
    } = this.state;
    const headroomTop = Boolean(viewportTopPos < headerHeight);
    const headerClasses = `${navOpen ? 'nav-open' : ''}${scrollingUp ? ' scrolling-up' : ''}${headroomTop ? ' headroom--top' : ' headroom--not-top'}`;
    return (
      <header
        className={`header ${headerClasses}`}
        ref={headerRef => this.headerRef = headerRef}
      >
        <Wrapper>
          <div className="container">
            <Logo size="large" colour="dark" clickable />
            {!isMobile && (
              <Navigation
                navigation={primaryMenu}
                location={location}
              />
            )}
            {isMobile && (
              <MobileNavigationButton
                navOpen={navOpen}
                toggleNavHandler={toggleNavHandler}
              />
            )}
          </div>
        </Wrapper>
      </header>
    );
  }
}

export default Header;
